export default {"src":"/_next/static/media/edit.b5c055ac.svg","height":24,"width":24};